var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIsle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_2303)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.0002 0C37.2551 0 48.0002 10.7452 48.0002 24H0.000244141C0.000244141 10.7452 10.7454 0 24.0002 0Z",
    fill: "#F1564C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0005 7C33.3893 7 41.0005 14.6112 41.0005 24H7.00049C7.00049 14.6112 14.6116 7 24.0005 7Z",
    fill: "#FC8B46"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0002 15C28.9708 15 33.0002 19.0294 33.0002 24H15.0002C15.0002 19.0294 19.0297 15 24.0002 15Z",
    fill: "#FDBB53"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.94093 27H21.0899C21.8665 27 22.4961 27.6326 22.4961 28.413C22.4961 28.7232 22.3945 29.0249 22.2069 29.2713L12.2381 42.3705C11.7027 43.0739 10.7013 43.2081 10.0012 42.6702C9.88905 42.584 9.78876 42.4832 9.70298 42.3705L0.396115 30.1412C-0.256317 29.2839 -0.0935782 28.0574 0.759602 27.4019C1.0988 27.1412 1.51393 27 1.94093 27Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.9065 27H46.0555C47.1296 27 48.0002 27.8749 48.0002 28.9541C48.0002 29.3832 47.8597 29.8003 47.6003 30.1412L38.2935 42.3705C37.7581 43.0739 36.7566 43.2081 36.0566 42.6702C35.9444 42.584 35.8441 42.4832 35.7584 42.3705L25.7895 29.2713C25.3177 28.6514 25.4354 27.7646 26.0523 27.2906C26.2976 27.1021 26.5978 27 26.9065 27Z",
    fill: "#2A3638"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00049 27H41.0005L25.3457 47.3368C24.7716 48.0826 23.704 48.22 22.961 47.6437C22.8465 47.5549 22.7438 47.4518 22.6553 47.3368L7.00049 27Z",
    fill: "#5F6257"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0005 27H32.0005L24.5573 36.7254C24.323 37.0316 23.8838 37.0907 23.5763 36.8574C23.5263 36.8195 23.4817 36.7751 23.4437 36.7254L16.0005 27Z",
    fill: "#919078"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_2303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsle);
export default __webpack_public_path__ + "static/media/isle.c00cb4bc17ca967ceddadfc4dc400db7.svg";
export { ForwardRef as ReactComponent };